import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode, Fragment, renderList, createBlock, normalizeClass, createVNode, createCommentVNode } from "vue";
import UgcImage from "../UgcImage/UgcImage.mjs";
import { getParentElement } from "../../util/dom.mjs";
import OptOutsideImage from "./OptOutsideImage.mjs";
const _hoisted_1 = {
  class: "ugc-cmp__container"
};
const _hoisted_2 = {
  class: "ugc-cmp__ops-outside-figure-wrapper"
};
const _hoisted_3 = {
  class: "ugc-cmp__image ugc-cmp__ops-outside-figure"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UgcComponent",
  props: {
    images: {}
  },
  emits: ["metricsClick", "ugcImageClick", "imageSelected"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const processedImages = computed(() => {
      const {
        length
      } = props.images || [];
      return length > 4 ? props.images.slice(0, 4) : props.images;
    });
    const extraImageSize = computed(() => {
      const {
        value: images
      } = processedImages;
      const length = (images == null ? void 0 : images.length) || 0;
      let tableHeight = "100%";
      if (length === 2) {
        tableHeight = "25.6rem";
      } else if (length === 3) {
        tableHeight = "50%";
      }
      const sizes = {
        "--images-count": length,
        "--has-many-images": length > 1 ? 1 : 0,
        "--opt-out-display": length < 4 ? "flex" : "none",
        "--opt-margins": length === 3 ? "0.2rem 0 5.2rem" : "0.2rem 0 4.8rem",
        "--opt-tablet-height": tableHeight,
        "--opt-desktop-size": 4 - length
      };
      return sizes;
    });
    function emitEvents({
      el,
      product,
      image,
      index
    }) {
      var _a;
      emit("ugcImageClick", {
        el,
        product
      });
      emit("imageSelected", {
        image,
        caption: `${index + 1} of ${(_a = props.images) == null ? void 0 : _a.length}`
      });
    }
    function handleUgcImageClick({
      el,
      product,
      event
    }, image, index) {
      event.stopPropagation();
      emitEvents({
        el,
        product,
        image,
        index
      });
    }
    function handleClick(event, image, index) {
      const target = event.target;
      const ugcContainer = getParentElement(target, {
        parentClass: "ugc-image__hotspots"
      });
      const el = ugcContainer == null ? void 0 : ugcContainer.querySelector(".ugc-image__hotspot--current");
      const {
        currentProductId,
        products
      } = image;
      const product = products == null ? void 0 : products.find((p) => p.metadata.productId === currentProductId);
      emitEvents({
        el,
        product,
        image,
        index
      });
    }
    __expose({
      extraImageSize
    });
    return (_ctx, _cache) => {
      return processedImages.value.length > 0 ? (openBlock(), createElementBlock("section", {
        key: 0,
        class: "ugc-cmp__wrapper",
        style: normalizeStyle(extraImageSize.value)
      }, [createElementVNode("div", _hoisted_1, [(openBlock(true), createElementBlock(Fragment, null, renderList(processedImages.value, (image, index) => {
        return openBlock(), createBlock(UgcImage, {
          key: image.id,
          id: image.id,
          class: normalizeClass(["ugc-cmp__image", {
            "ugc-cmp__image--single": processedImages.value.length === 1
          }]),
          "image-src": image.uri,
          "is-focusable": true,
          layout: "vertical",
          "expandable-hotspot": true,
          likes: image.likes,
          "posted-date": image.postedDate,
          products: image.products,
          title: image.title || "",
          user: image.user,
          "current-product-id": image.currentProductId,
          "zoom-background": false,
          onClick: ($event) => handleClick($event, image, index),
          onUgcImageClick: (data) => handleUgcImageClick(data, image, index),
          onMetricsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("metricsClick", data))
        }, null, 8, ["id", "class", "image-src", "likes", "posted-date", "products", "title", "user", "current-product-id", "onClick", "onUgcImageClick"]);
      }), 128)), createElementVNode("div", _hoisted_2, [createElementVNode("figure", _hoisted_3, [createVNode(OptOutsideImage, {
        class: "ugc-cmp__ops-outside-figure-image"
      }), _cache[1] || (_cache[1] = createElementVNode("figcaption", {
        class: "ugc-cmp__ops-outside-figure-caption"
      }, " Opt outside with @REI and members like you on Instagram #REImember ", -1))])])])], 4)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=UgcComponent2.mjs.map
